import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonModalService } from 'app/services/common-modal.service';
import { ConfirmModalData } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { EditService, LeaveWarningResponse } from 'app/services/edit.service';

export interface ComponentCanDeactivate {
	canDeactivate: () => boolean | Observable<boolean>;
	onUserRespondToLeaving: (response: LeaveWarningResponse) => any;
}

@Injectable({
	providedIn: 'root'
})
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
	constructor(
		private editService: EditService
	) {}
	async canDeactivate(component: ComponentCanDeactivate) {
		if (component.canDeactivate()) {
			return true;
		} else {
			const rsp = await this.editService.warnOnLeave();
			if (rsp === false) {
				return false;
			} else {
				if (component.onUserRespondToLeaving) {
					await component.onUserRespondToLeaving(rsp);
				}
				return true;
			}
		}
	}


}
